import request from '@/utils/request'

const dataObj = {
	version: '1.0',
	nonceStr: '1212fsadf',
	timestamp: '2020-4-21',
	signType: 'md5',
	content: { object: { merchantId: 1 } },
	sign: 'dafdsf'
}
// 分页查询系统日志
export function getLogList (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v2/alloc/log-record/page',
		method: 'post',
		data: obj
	})
}
// 分页查询打印信息
export function ntcPrintInfo (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/ntcPrintInfo/page',
		method: 'get',
		params: obj
	})
}
// 查询打印记录
export function ntcPrintInfoDetail (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/ntcPrintInfoMsg/page',
		method: 'get',
		params: obj
	})
}
// 查询投诉建议消息
export function getComplaintPage (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/complaint/getPlaintByPage',
		method: 'get',
		params: obj
	})
}
// 回复功能
export function replyComplaint (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/complaint/replyComplaint',
		method: 'post',
		data: obj
	})
}
// 评价管理查询评价列表
export function getEvaluateList (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/applet/menuevaluaorder/page/evaluate/order',
		method: 'post',
		data: obj
	})
}
// 评价管理评价展示与屏蔽
export function evaluateFlag (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/applet/menuevaluaorder/edit/show/flag',
		method: 'post',
		data: obj
	})
}
// 导出系统日志生成
export const genExcelFile = (data) => {
	return request({
		url: '/api/v2/alloc/log-record/genExcelFile',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
// 获取导出文件下载地址
export const getExcelFileUrl = (data) => {
	return request({
		url: '/api/v2/alloc/log-record/getExcelFileUrl',
		method: 'post',
		data: { ...dataObj, content: data || undefined }
	})
}
